import type { Omraade } from "$lib/types/omraade";

export type AreaCode = "NO1" | "NO2" | "NO3" | "NO4" | "NO5";

export const isAreaCode = (area: string): area is AreaCode => ["NO1", "NO2", "NO3", "NO4", "NO5"].includes(area);

export const selectAreas: Omraade[] = [
  {
    value: "NO1",
    label: "Sørøst-Norge",
    shortLabel: "Sørøst",
    urlLabel: "sorost",
  },
  {
    value: "NO2",
    label: "Sørvest-Norge",
    shortLabel: "Sørvest",
    urlLabel: "sorvest",
  },
  {
    value: "NO3",
    label: "Midt-Norge",
    shortLabel: "Midt",
    urlLabel: "midt",
  },
  {
    value: "NO4",
    label: "Nord-Norge",
    shortLabel: "Nord",
    urlLabel: "nord",
  },
  {
    value: "NO5",
    label: "Vest-Norge",
    shortLabel: "Vest",
    urlLabel: "vest",
  },
];

export const selectAreasExtended: Omraade[] = [
  ...selectAreas,
  {
    value: "NO4-2",
    label: "Nord-Troms/Finnmark",
    shortLabel: "Troms/Finnmark",
    urlLabel: "troms-finnmark",
  },
];
